import { render, staticRenderFns } from "./tradedetailomni.vue?vue&type=template&id=cb1107c8&scoped=true"
import script from "./tradedetailomni.vue?vue&type=script&lang=js"
export * from "./tradedetailomni.vue?vue&type=script&lang=js"
import style0 from "./tradedetailomni.vue?vue&type=style&index=0&id=cb1107c8&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1107c8",
  null
  
)

export default component.exports